import { ResponseArray, ResponseObject } from '@/types/shared'
import datacentral from '@/utils/axios/datacentral'
import { InternalTicketWorkflow } from '../types'

export const getInternalTicketWorkflow = async (serviceId: number) => {
    const response = await datacentral.get<
        ResponseArray<InternalTicketWorkflow>
    >(`/internal-tickets/services/${serviceId}`)
    return response.data?.results
}

export const getInternalTicketWorkflowByTicketId = async (ticketId: number) => {
    const response = await datacentral.get<
        ResponseObject<InternalTicketWorkflow>
    >(`/internal-tickets/tickets/${ticketId}`)
    return response.data?.result
}

export const resolveInternalTicketWorkflowByStepId = async ({
    stepId,
    filledData,
}: {
    stepId: number
    filledData?: Record<string, any>
}) => {
    const response = await datacentral.post<
        ResponseObject<InternalTicketWorkflow>
    >(`/internal-tickets/steps/${stepId}/complete`, {
        ...(filledData && { filled_data: filledData }),
    })
    return response.data?.result
}

export const rejectInternalTicketWorkflowByStepId = async ({
    stepId,
    reason,
}: {
    stepId: number
    reason: string
}) => {
    const response = await datacentral.post<
        ResponseObject<InternalTicketWorkflow>
    >(`/internal-tickets/steps/${stepId}/reject`, {
        reason,
    })
    return response.data?.result
}
